import axios from 'axios';
import { WSREST_TABATA, SITE, NOME_APP } from '../config';

export const checkMerlino = async () => {
  return new Promise((resolve, reject) => {
    const merlinoR = getMerlinoR();
    const exp = getMerlinoExp();
    const userid = getMerlinoID();
    const fiveMinutesInMillis = 300000;

    if (merlinoR != null && exp != null) {
      // Controlla se in 5 minuti scade.
      const expired = parseInt(Date.parse(exp)) - fiveMinutesInMillis < Date.now();

      if (expired) {
        // Se expired ed esiste il refresh token, refreshalo ...
        axios.post(`${WSREST_TABATA}refreshtoken/${SITE}/${NOME_APP}`, {
          userid: userid,
          token: merlinoR,
        })
          .then((res) => {
            // Salva nel session storage il nuovo JWT
            if (res.status === 200) {
              refreshMerlino(res.data);
              resolve();
            } else {
              console.log('Errore refresh token');
              clearMerlino();
              reject();
            }
          })
          .catch((err) => {
            clearMerlino();
            reject(err);
          });
      } else {
        resolve();
      }
    } else {
      resolve();
    }
  });
};

// Funzioni di gestione del token
export const getMerlinoT = () => sessionStorage.getItem('mT');
export const getMerlinoR = () => sessionStorage.getItem('mR');
export const getMerlinoExp = () => sessionStorage.getItem('mEx');
export const getMerlinoID = () => sessionStorage.getItem('mID');

export const setMerlino = (res) => {
  sessionStorage.setItem('mT', res.t);
  sessionStorage.setItem('mR', res.tr);
  sessionStorage.setItem('mEx', res.tex);
  sessionStorage.setItem('mID', res.u.userid);
};

export const refreshMerlino = (res) => {
  sessionStorage.setItem('mT', res.t);
  //sessionStorage.setItem('mR', res.tr);
  sessionStorage.setItem('mEx', res.tex);
};

export const clearMerlino = () => {
  sessionStorage.removeItem('mT');
  sessionStorage.removeItem('mR');
  sessionStorage.removeItem('mEx');
  sessionStorage.removeItem('mID');
  sessionStorage.removeItem('mU');
};
